module.exports = __webpack_public_path__ + "static/media/four_four_rests.507be40a.png";